// src/components/ui/card.jsx
import * as React from 'react';

// Simple className combiner
const cx = (...a) => a.filter(Boolean).join(' ');

// Shared calm styles
const baseCard =
  'rounded-2xl border border-slate-700/70 bg-slate-900/70 backdrop-blur-xl shadow-sm';
const headerCard =
  'px-4 py-3 border-b border-slate-700/70 flex items-center justify-between';
const footerCard =
  'px-4 py-3 border-t border-slate-700/70';

export const Card = React.forwardRef(function Card({ className = '', ...props }, ref) {
  return <div ref={ref} className={cx(baseCard, className)} {...props} />;
});
Card.displayName = 'Card';

export const CardHeader = React.forwardRef(function CardHeader({ className = '', ...props }, ref) {
  return <div ref={ref} className={cx(headerCard, className)} {...props} />;
});
CardHeader.displayName = 'CardHeader';

export const CardTitle = React.forwardRef(function CardTitle({ className = '', ...props }, ref) {
  return (
    <h3
      ref={ref}
      className={cx('text-base font-semibold leading-none tracking-tight text-white', className)}
      {...props}
    />
  );
});
CardTitle.displayName = 'CardTitle';

export const CardDescription = React.forwardRef(function CardDescription({ className = '', ...props }, ref) {
  return <p ref={ref} className={cx('text-sm text-slate-400', className)} {...props} />;
});
CardDescription.displayName = 'CardDescription';

export const CardContent = React.forwardRef(function CardContent({ className = '', ...props }, ref) {
  return <div ref={ref} className={cx('p-4 text-white', className)} {...props} />;
});
CardContent.displayName = 'CardContent';

export const CardFooter = React.forwardRef(function CardFooter({ className = '', ...props }, ref) {
  return <div ref={ref} className={cx(footerCard, className)} {...props} />;
});
CardFooter.displayName = 'CardFooter';
